document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-social-proof]');
  if (!root) return;

  const signal = String(root.dataset.signal || 'both').toLowerCase();
  const allowViewers = signal === 'both' || signal === 'viewers';
  const allowBuys = signal === 'both' || signal === 'buys';

  const viewersEl = root.querySelector('[data-sp-viewers]');
  const buysEl = root.querySelector('[data-sp-buys]');
  const hoursEl = root.querySelector('[data-sp-hours]');

  const blueBar = root.querySelector('[data-proof-bar="viewing"]');
  const orangeBar = root.querySelector('[data-proof-bar="bought"]');

  const minV = parseInt(root.dataset.minViewers || '4', 10);
  const maxV = parseInt(root.dataset.maxViewers || '12', 10);
  const minB = parseInt(root.dataset.minBuys || '6', 10);
  const maxB = parseInt(root.dataset.maxBuys || '24', 10);
  const hours = parseInt(root.dataset.hours || '48', 10);

  const rand = (a, b) => Math.floor(Math.random() * (b - a + 1)) + a;

  function showBar(bar) {
    if (!bar) return;
    bar.classList.remove('is-hidden');
    bar.classList.add('is-visible');
  }

  function hideBar(bar) {
    if (!bar) return;
    bar.classList.remove('is-visible');
    bar.classList.add('is-hidden');
  }

  // always start hidden
  hideBar(blueBar);
  hideBar(orangeBar);

  // OFF means show nothing
  if (signal === 'off' || (!allowViewers && !allowBuys)) return;

  // set numbers once
  if (allowViewers && viewersEl) viewersEl.textContent = String(rand(minV, maxV));
  if (allowBuys && buysEl) buysEl.textContent = String(rand(minB, maxB));
  if (hoursEl) hoursEl.textContent = String(hours);

  // timing (only schedule what’s allowed)
  const blueDelayIn = 0;
  const orangeDelayIn = 700;
  const blueVisibleFor = 5200;
  const orangeVisibleFor = 5200;

  if (allowViewers) {
    window.setTimeout(() => showBar(blueBar), blueDelayIn);
    window.setTimeout(() => hideBar(blueBar), blueDelayIn + blueVisibleFor);
  }

  if (allowBuys) {
    window.setTimeout(() => showBar(orangeBar), orangeDelayIn);
    window.setTimeout(() => hideBar(orangeBar), orangeDelayIn + orangeVisibleFor);
  }
});